import { render, staticRenderFns } from "./CompletedStudyFormNewVersion.vue?vue&type=template&id=d74d2afe&scoped=true"
import script from "./CompletedStudyFormNewVersion.vue?vue&type=script&lang=js"
export * from "./CompletedStudyFormNewVersion.vue?vue&type=script&lang=js"
import style0 from "./CompletedStudyFormNewVersion.vue?vue&type=style&index=0&id=d74d2afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74d2afe",
  null
  
)

export default component.exports